import { useCallback } from 'react';
import { useDispatch, batch } from 'react-redux';
import { log } from 'log';

import * as actions from '../store/actions';
import { TLiveGamesResponseMessage } from '../types';

export const useLiveGamesOnSocketMessage = () => {
    const dispatch = useDispatch();

    return useCallback((message: TLiveGamesResponseMessage): void => {
        if ('subscribeResponse' in message) {
            if (message.subscribeResponse.result?.errorType !== 0) {
                log('log', '[LIVE | Portal] subscribeRequest failed', message.subscribeResponse);

                return;
            }

            dispatch(actions.addSubscription({
                correlationId: message.correlationId,
                tables: message.subscribeResponse.tables || [],
                subscriptionId: message.subscribeResponse.subscriptionId
            }));

            log('log', '[LIVE | Portal] subscribeResponse received', message.subscribeResponse);
        } else if ('updateNotification' in message) {
            if (message.updateNotification.updatedTables) {
                dispatch(actions.updateTables({
                    tables: message.updateNotification.updatedTables,
                    subscriptionId: message.updateNotification.subscriptionId
                }));
            }

            if (message.updateNotification.addedTables) {
                dispatch(actions.addTables({
                    tables: message.updateNotification.addedTables,
                    subscriptionId: message.updateNotification.subscriptionId
                }));
            }

            if (message.updateNotification.launchAliasesOfRemovedTables) {
                dispatch(actions.removeTables({
                    tables: message.updateNotification.launchAliasesOfRemovedTables,
                    subscriptionId: message.updateNotification.subscriptionId
                }));
            }

            log('log', '[LIVE | Portal] updateNotification received', message.updateNotification);
        } else if ('unsubscribeResponse' in message) {
            if (message.unsubscribeResponse.result?.errorType !== 0) {
                log('log', '[LIVE | Portal] unsubscribeRequest failed', message.unsubscribeResponse);

                return;
            }

            dispatch(actions.removeSubscription(message.unsubscribeResponse.subscriptionIds));

            log('log', '[LIVE | Portal] unsubscribeResponse received', message.unsubscribeResponse);
        } else if ('setContextResponse' in message) {
            log('log', '[LIVE | Portal] setContextResponse received', message.setContextResponse);

            if (message.setContextResponse.result?.errorType !== 0) {
                batch(() => {
                    dispatch(actions.updateContextStatus(false));
                    dispatch(actions.updateIsNeedToStart(false));
                });

                return;
            }

            dispatch(actions.updateContextStatus(true));
        } else if ('serverPing' in message) {
            // do nothing
        } else {
            log('log', '[LIVE | Portal] unknown message received', message);
        }
    }, [dispatch]);
};
